import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { queryError } from "../services/queryError";
import {
  fetchDeliveryStates,
  fetchDeliveryLGAs,
} from "../services/locationService";

const staticDataOptions = {
  staleTime: 24 * 60 * 60 * 1000, // 24 hours
  gcTime: 7 * 24 * 60 * 60 * 1000, // 7 days persistent cache
  refetchOnReconnect: true,
  refetchOnWindowFocus: false,
};

export const useDeliveryStates = (options = {}) => {
  const query = useQuery({
    queryKey: ["deliveryStates"],
    queryFn: fetchDeliveryStates,
    ...staticDataOptions,
  });

  const { showToast, navigate } = options;

  useEffect(() => {
    if (query.isError) {
      queryError(query.error, showToast, navigate);
    }
  }, [query.isError, query.error, showToast, navigate]);

  return query;
};

export const useDeliveryLGAs = (stateId, options = {}) => {
  const query = useQuery({
    queryKey: ["deliveryLGAs", stateId],
    queryFn: () => fetchDeliveryLGAs(stateId),
    enabled: !!stateId,
    staleTime: 10 * 60 * 1000, // 10 minutes — deliveryDays can change server-side
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  const { showToast, navigate } = options;

  useEffect(() => {
    if (query.isError) {
      queryError(query.error, showToast, navigate);
    }
  }, [query.isError, query.error, showToast, navigate]);

  return query;
};
